import "bootstrap/dist/css/bootstrap.min.css";

import { Container } from "react-bootstrap";

function CenterJang() {
  return (
    <Container fluid>
      <h1>센터장 소개</h1>

      <h3>이정옥</h3>
      <h5>교육 및 경력</h5>
      <p>
        전 빙벽 국가대표<br></br>전 클라이밍 국가대표<br></br>
        경기지도자 2급<br></br>
        심판 2급<br></br>
        체육 실기교사 교원 자격<br></br>
        생활체육 지도사 자격<br></br>
        1997년 유학산 학바위, 둥지바위 개척팀<br></br>
        2000년 파워 게임 개최(전국 최초 볼더링대회)<br></br>
      </p>
      <h5>수상경력</h5>
      <p>
        1997년 대구시연맹 대구 암벽대회 1위<br></br>
        1998년 대구시연맹 대구 암벽대회 1위<br></br>
        1999년 전주 스파이더 볼더 대회 5위<br></br>
        1999년 대구시 연맹 암벽대회 2위<br></br>
        1999년 부산 우정 전국 암벽 대회 4위<br></br>
        1999년 서울시연맹 전국 등반경기대회 2위<br></br>
        1999년 인천시연맹 전국 등반경기대회 3위<br></br>
        2000년 부산 우정 전국 암벽 대회 4위<br></br>
        2000년 울릉도 사랑 전국 등반경기대회 5위<br></br>
        2000년 인천 시장배 전국 등반경기대회 4위<br></br>
        2000년 제1회 인공등반경기대회 2위<br></br>
        2001년 제10회 회장배 전국등반경기대회 2위<br></br>
        2001년 말레이지아 월드컵 23위<br></br>
        2002년 중국 국제 초청 경기 자연암벽8위, 인공암벽 14위<br></br>
        2002년 아시아 선수권대회 20위<br></br>
        2002년 울산암벽대회 2위<br></br>
        2002년 대전암벽대회 2위<br></br>
        2003년 제23회 전국등반경기 선수권대회 5위<br></br>
        2003년 제84회 전국체전 여자 일반부 4위<br></br>
        2004년 제1회 청송 전국빙벽등반경기대회 2위<br></br>
        2004년 제7회 서울 시장기 전국등반경기대회 4위<br></br>
        2004년 대구 익스트림 등반경기대회 5위<br></br>
        2005년 전국 빙벽등반경기 선수권대회 3위<br></br>
        2005년 제86회 전국체전 여자 일반부 5위<br></br>
        2006년 제27회 전국등반경기선수권대회 1위<br></br>
        2006년 제87회 전국체전 대학부 1위<br></br>
        2007년 제88회 전국체전 대학부 1위<br></br>
        2007년 노스페이스 아이스클라이밍 페스티벌 3위<br></br>
        2008년 전국 빙벽등반경기 선수권대회 3위<br></br>
      </p>
    </Container>
  );
}

export default CenterJang;
